export type Priority = 'Critical' | 'High' | 'Medium' | 'Low';

const KNOWN_PRIORITIES = new Set<string>(['Critical', 'High', 'Medium', 'Low']);

/** True when `name` is one of the closed-set Priority values. */
export function isPriority(name: string | null | undefined): name is Priority {
  return name !== null && name !== undefined && KNOWN_PRIORITIES.has(name);
}
